export const accommRsvEditorActions = {
  SET_RSV_VALUE: '@@accommRsvEditor/SET_RSV_VALUE',
};
